
  
  
 import React, { useEffect, useState, useRef } from "react";
import {
  FaSignOutAlt,
  FaBars,
  FaUserCircle,
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaEye,
  FaCheck,
  FaCertificate,
  FaDownload,
  FaSearch,
} from "react-icons/fa";
import {
  MdApps,
  MdBadge,
  MdBuild,
  MdBusiness,
  MdBusinessCenter,
  MdCategory,
  MdDashboard,
  MdEvent,
  MdGrade,
  MdGroup,
  MdHome,
  MdImage,
  MdInsertChart,
  MdLink,
  MdList,
  MdMenu,
  MdPerson,
  MdPhotoLibrary,
  MdPostAdd,
  MdSettings,
  MdSlideshow,
  MdStar,
  MdStore,
  MdTv,
  MdVerified,
  MdWork,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  FacebookEmbed,
  InstagramEmbed,
  YouTubeEmbed,
} from "react-social-media-embed"
import { State, City } from "country-state-city";
import './Admin.css';

const API = "https://api.propertygalleria.in";
  
 export const PropertiesMenu = () => { 
  
  const [categories, setCategories] = useState([]);
const [types, setTypes] = useState([]);

const [categoryName, setCategoryName] = useState("");
const [typeName, setTypeName] = useState("");
const [selectedCategory, setSelectedCategory] = useState("");

const [editingIdC, setEditingIdC] = useState(null);

const [editingIdT, setEditingIdT] = useState(null);

const editCategory = (c) => {
  setEditingIdC(c.id);
  setCategoryName(c.category_name);
};

const editType = (t) => {
  setEditingIdT(t.id);
  setSelectedCategory(t.category_id);
  setTypeName(t.type_name);
};


// Pagination
const [currentPageC, setCurrentPageC] = useState(1);
const itemsPerPageC = 5;



// Pagination for Types
const [currentPageT, setCurrentPageT] = useState(1);
const itemsPerPageT = 5;



const fetchData = async () => {
  const cat = await axios.get(`${API}/api/property-categories`);
  const typ = await axios.get(`${API}/api/property-types`);
  setCategories(cat.data);
  setTypes(typ.data);
};

useEffect(() => {
  fetchData();
}, []);



const addCategory = async () => {
  await axios.post(`${API}/api/property-categories`, {
    category_name: categoryName,
  });
  setCategoryName("");
  fetchData();
};



const addType = async () => {
  if (!selectedCategory || !typeName) return alert("Select category & enter type");
  await axios.post(`${API}/api/property-types`, {
    category_id: selectedCategory,
    type_name: typeName,
  });
  setTypeName("");
  fetchData();
};

const updateCategory = async () => {
  await axios.put(
    `${API}/api/property-categories/${editingIdC}`,
    { category_name: categoryName }
  );
  setEditingIdC(null);
  setCategoryName("");
  fetchData();
};

const updateType = async () => {
  await axios.put(
    `${API}/api/property-types/${editingIdT}`,
    {
      category_id: selectedCategory,
      type_name: typeName,
    }
  );
  setEditingIdT(null);
  setTypeName("");
  setSelectedCategory("");
  fetchData();
};

const deleteCategory = async (id) => {
  if (!window.confirm("Delete this category?")) return;
  await axios.delete(`${API}/api/property-categories/${id}`);
  fetchData();
};



const deleteType = async (id) => {
  if (!window.confirm("Delete this type?")) return;
  await axios.delete(`${API}/api/property-types/${id}`);
  fetchData();
};


const totalPagesC = Math.ceil(categories.length / itemsPerPageC);
const totalPagesT = Math.ceil(types.length / itemsPerPageT);

  return (
    <div style={{ background: "#f4f6f8", padding: 20, borderRadius: 12 }}>

      <h2 style={{ color: "var(--primary)", marginBottom: 20 }}>
        Properties Menu
      </h2>

 {/* FORM CARDS */}
<div style={{ display: "flex", gap: 20, marginBottom: 25 }}>

  {/* CATEGORY CARD */}
  <div style={{ ...cardStyle, display: "flex", flexDirection: "column" }}>
    <h4>Property Category</h4>

    <input
      value={categoryName}
      onChange={(e) => setCategoryName(e.target.value)}
      style={inputStyle}
      placeholder="Residential / Commercial"
    />

    <button
      onClick={editingIdC ? updateCategory : addCategory}
      style={{ ...primaryBtn, marginTop: "auto" }} // push button to bottom
    >
      {editingIdC ? "Update Category" : "Add Category"}
    </button>
  </div>

  {/* TYPE CARD */}
  <div style={{ ...cardStyle, display: "flex", flexDirection: "column" }}>
    <h4>Property Type</h4>

    <select
      value={selectedCategory}
      onChange={(e) => setSelectedCategory(e.target.value)}
      style={inputStyle}
    >
      <option value="">Select Category</option>
      {categories.map((c) => (
        <option key={c.id} value={c.id}>
          {c.category_name}
        </option>
      ))}
    </select>

    <input
      value={typeName}
      onChange={(e) => setTypeName(e.target.value)}
      style={inputStyle}
      placeholder="Flats / Villas / Offices"
    />

    <button
      onClick={editingIdT ? updateType : addType}
      style={{ ...primaryBtn, marginTop: "auto" }} // push button to bottom
    >
      {editingIdT ? "Update Type" : "Add Type"}
    </button>
  </div>
</div>


      {/* TABLE ROW */}
      <div style={{ display: "flex", gap: 20, marginTop: 20 }}>

        {/* CATEGORY TABLE */}
        <div style={{ flex: 1 }}>
          {/* <h3 style={{ color: "var(--primary)", marginBottom: 10 }}>Categories</h3> */}
          <table style={{ width: "100%", border: "1px solid #42987e" }}>
            <thead style={{ background: "var(--pg-primary)", color: "#fff" }}>
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Actions</th>
              </tr>
            </thead>
        <tbody>
  {categories.slice(
    (currentPageC - 1) * itemsPerPageC,
    currentPageC * itemsPerPageC
  ).map((c, i) => (
    <tr key={c.id}>
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1 + (currentPageC - 1) * itemsPerPageC}</td> {/* Correct row number */}
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{c.category_name}</td>
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
        <FaEdit onClick={() => editCategory(c)} style={actionIcon} />
        <FaTrash
          onClick={() => deleteCategory(c.id)}
          style={{ ...actionIcon, color: "var(--pg-secondary)" }}
        />
      </td>
    </tr>
  ))}
</tbody>
          </table>
{/* Categories Pagination */}
{totalPagesC > 1 && (
  <div
    style={{
      marginTop: 20,
      display: "flex",
      justifyContent: "center",
      gap: 6,
    }}
  >
    <button
      disabled={currentPageC === 1}
      onClick={() => setCurrentPageC((p) => p - 1)}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        background: currentPageC === 1 ? "#eee" : "var(--pg-secondary)",
        color: currentPageC === 1 ? "#555" : "#fff",
        border: "none",
        cursor: currentPageC === 1 ? "not-allowed" : "pointer",
      }}
    >
      Prev
    </button>

    {Array.from({ length: totalPagesC }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPageC(page)}
        style={{
          padding: "6px 10px",
          borderRadius: 6,
          background: currentPageC === page ? "var(--pg-secondary)" : "#fff",
          color: currentPageC === page ? "#fff" : "#333",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      >
        {page}
      </button>
    ))}

    <button
      disabled={currentPageC === totalPagesC}
      onClick={() => setCurrentPageC((p) => p + 1)}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        background: currentPageC === totalPagesC ? "#eee" : "var(--pg-secondary)",
        color: currentPageC === totalPagesC ? "#555" : "#fff",
        border: "none",
        cursor: currentPageC === totalPagesC ? "not-allowed" : "pointer",
      }}
    >
      Next
    </button>
  </div>
)}


        </div>

        {/* TYPES TABLE */}
        <div style={{ flex: 1 }}>
          {/* <h3 style={{ color: "var(--primary)", marginBottom: 10 }}>Types</h3> */}
          <table style={{ width: "100%", border: "1px solid #42987e" }}>
            <thead style={{ background: "var(--pg-primary)", color: "#fff" }}>
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
 <tbody>
  {types.slice(
    (currentPageT - 1) * itemsPerPageT,
    currentPageT * itemsPerPageT
  ).map((t, i) => (
    <tr key={t.id}>
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{i + 1 + (currentPageT - 1) * itemsPerPageT}</td>
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{categories.find(c => c.id === t.category_id)?.category_name}</td>
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>{t.type_name}</td>
      <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
        <FaEdit onClick={() => editType(t)} style={actionIcon} />
        <FaTrash
          onClick={() => deleteType(t.id)}
          style={{ ...actionIcon, color: "var(--pg-secondary)" }}
        />
      </td>
    </tr>
  ))}
</tbody>
          </table>
{/* Types Pagination */}
{totalPagesT > 1 && (
  <div
    style={{
      marginTop: 20,
      display: "flex",
      justifyContent: "center",
      gap: 6,
    }}
  >
    <button
      disabled={currentPageT === 1}
      onClick={() => setCurrentPageT((p) => p - 1)}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        background: currentPageT === 1 ? "#eee" : "var(--pg-secondary)",
        color: currentPageT === 1 ? "#555" : "#fff",
        border: "none",
        cursor: currentPageT === 1 ? "not-allowed" : "pointer",
      }}
    >
      Prev
    </button>

    {Array.from({ length: totalPagesT }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPageT(page)}
        style={{
          padding: "6px 10px",
          borderRadius: 6,
          background: currentPageT === page ? "var(--pg-secondary)" : "#fff",
          color: currentPageT === page ? "#fff" : "#333",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      >
        {page}
      </button>
    ))}

    <button
      disabled={currentPageT === totalPagesT}
      onClick={() => setCurrentPageT((p) => p + 1)}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        background: currentPageT === totalPagesT ? "#eee" : "var(--pg-secondary)",
        color: currentPageT === totalPagesT ? "#555" : "#fff",
        border: "none",
        cursor: currentPageT === totalPagesT ? "not-allowed" : "pointer",
      }}
    >
      Next
    </button>
  </div>
)}


        </div>

      </div>
    </div>
  );

}


/* ---------- Styles ---------- */

const baseStyles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Segoe UI, sans-serif",
   /* PG ADMIN BACKGROUND */
background: "var(--pg-bg)",

  },
  sidebar: {
   background: "linear-gradient(180deg, var(--pg-primary), var(--pg-accent))",
    color: "#fff",
    transition: "width 0.3s ease",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    padding: "15px 10px",
    boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  logoArea: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  logoBlock: { lineHeight: 1.2,     marginTop: "8px", marginBottom: "8px",  },

  logoAccent: {
    color: "var(--pg-secondary)",
    fontWeight: "700",
    fontSize: "0.85rem",
    marginLeft: "4px",
       background: "rgba(255, 255, 255, 0.5)",
borderRadius: "8px",
 textTransform:"uppercase",
 padding:'5px',
  filter: "drop-shadow(0 2px 8px #fff)",

  },
  logoTagline: {
    fontSize: "0.7rem",
    color: "#c9d1d9",
    marginTop: "3px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 14px",
    marginBottom: "8px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  navIcon: { fontSize: "18px", marginRight: "10px" },
  navLabel: { fontSize: "15px", fontWeight: "500" },
  mainArea: (sidebarOpen) => ({
    marginLeft: sidebarOpen ? "220px" : "70px",
    transition: "margin-left 0.3s ease",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  contentWrapper: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
 logoContainer: {
    display: "inline-flex", // Ensures it aligns well with other text elements
    justifyContent: "center", // Centers the text horizontally
    alignItems: "center", // Centers the text vertically
   background: "rgba(255, 255, 255, 0.5)", borderRadius: "50%", // Ensures the shape is a circle filter: "drop-shadow(0 2px 8px #fff)", // Makes the whole container circular
   width: "42px",  height: "42px", // Set a fixed height (should match width for a circle) padding: "0",, // Padding to create space around the letters
    filter: "drop-shadow(0 2px 8px #fff)", // Same drop shadow for the whole logo
  },

  logoMain: { fontWeight: "800", color: "#fff", fontSize: "1.1rem", letterSpacing: "0.5px",    marginTop: "14px",     textTransform: "uppercase",  },

  logoMain1: {
    color: "var(--pg-primary)", // Color for "P" (if you want to change, do it here)
    fontWeight: "800",
    fontSize: "1.3rem",
    letterSpacing: "0.5px",
    marginRight: "1px", // Margin to separate "P" from "G"
  },

  logoG: {
    color: "var(--pg-secondary)", // Color for "G"
    fontWeight: "700",
    fontSize: "1.3rem",
    
  },
};

const headerStyles = {
  header: {
    height: "60px",
 /* PG HEADER THEME */
background: "linear-gradient(90deg, var(--pg-primary), var(--pg-secondary))",

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
  },
  leftGroup: { display: "flex", alignItems: "center" },
  toggleBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
  },
  profileArea: { position: "relative" },
  profileMenu: {
    position: "absolute",
    right: 0,
    top: "calc(100% + 10px)",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  profileMenuItem: {
    padding: "10px 10px",
    cursor: "pointer",
    color: "var(--pg-primary)",
    fontWeight: 500,
    borderBottom: "1px solid #eee",
   width:'160px'
  },
};

const contentStyles = {
 wrapper: {
/* PG GLASS CARD */
background: "rgba(255,255,255,0.92)",
backdropFilter: "blur(14px)",
border: "1px solid rgba(139,48,109,0.12)",

    borderRadius: "18px",
    padding: "35px",
    boxShadow:
      "0 14px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
    border: "1px solid rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(8px)",
    transition: "0.3s ease-in-out",
  },

  title: {
    margin: 0,
    marginBottom: "14px",
    fontSize: "1.9rem",
    fontWeight: "700",
    letterSpacing: "0.6px",
    background: "var(--pg-primary)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subtitle: {
    margin: 0,
    marginTop: "5px",
    fontSize: "1rem",
    color: "#555",
    fontWeight: "500",
    opacity: 0.85,
  },
  formRow: { display: "flex", gap: "10px", marginBottom: "20px" },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    flex: "0.3",
  },
  fileInput: {
    flex: "0.5",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  addBtn: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  thead: { background: "var(--primary)", color: "#fff" },
  th: {
    textAlign: "left",
    padding: "10px",
    fontWeight: "600",
  },
  td: { padding: "10px", borderBottom: "1px solid #eee" },
  btnEdit: {
    background: "var(--primary)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    marginRight: "6px",
    cursor: "pointer",
  },
  btnDelete: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
  },
  noData: { color: "#888", textAlign: "center", padding: "20px" },
};


const labelStyle = {
  display: "block",
  textAlign: "left",
  fontWeight: 600,
  marginBottom: 5,
    marginLeft: 5,
  color: "#333"
};

const inputStyle = {
  width: "95%",
  border: "1px solid #ccc",
  borderRadius: 6,
  padding: "8px",
  fontSize: 14,
  cursor: "pointer",
  marginBottom: 15
};

const cardStyle = {
  flex: 1,
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
};

const primaryBtn = {
  background: "var(--pg-secondary)",
  color: "#fff",
  padding: "10px 15px",
  borderRadius: 6,
  marginTop: 15,
  width: "100%",
  fontWeight: 600,
  fontSize: 15,
  cursor: "pointer",
  border: "none",
};

const actionIcon = {
  cursor: "pointer",
  marginRight: 12,
  color: "var(--pg-primary)",
};

const paginationStyle = {
  marginTop: 20,
  display: "flex",
  justifyContent: "center",
  gap: 6,
};
